module.exports = __webpack_public_path__ + "static/media/Vast-Shadow.016ffe50.svg";